<template>
    <div :class="holder_classname">
        <div v-if="arrow" :class="arrow_classname" @click="Scroll">
            <d-svg :src="icon"></d-svg>
        </div>
    </div>
</template>

<script setup>

import { computed, defineProps, defineEmits } from 'vue'
import icons from "@/dod/enums/dicons";

const emit = defineEmits(['scroll'])

const props = defineProps({
    position: { type: String, required: true },
    shadow: { type: Boolean, default: true },
    arrow: { type: Boolean, default: true }
})

const pos = computed(() => props.position?.toLowerCase() ?? 'top')

const icon = computed(() => {
    return icons.overflow_icons[pos.value];
})

const holder_classname = computed(() => {
    var cname = `d-overflow-holder d-overflow-holder-${pos.value}`;
    if(props.shadow)
        cname += ` d-overflow-shadow d-overflow-shadow-${pos.value}`;
    return cname;
})

const arrow_classname = computed(() => {
    var cname = `d-overflow-arrow pointer overflow-element d-overflow-arrow-${pos.value}`;
    return cname;
})

const Scroll = () => {
   emit('scroll', pos.value);
}

</script>